function BulkCostService(ApiService) {
  'ngInject';
  const service = {};

  service.getbulkJournals = function(orgId, url, pageNumber,size, callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.getJournal = function(orgId, journalId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/bulk_cost_journals/${journalId}.json`, callbackFunc);
  };

  service.getParameterByName = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  service.calculateBulkCostJournal = function(orgId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/calculate_bulk_cost.json`, callbackFunc);
  };

  service.retryBulkCostProcess = function(orgId, accountCode, journalDate, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/bulk_cost_journals/retry.json`, { account_code : accountCode, journal_date: journalDate }, callbackFunc);
  };

  return service;
}

export default{
  name: 'BulkCostService',
  fn: BulkCostService
};
